import StageLoading from "./00-Loading"
// import { StageHome } from "./01-Home"
import React from "react"
import { CommonTransition } from "@/components/CommonTransition"
import { DialogRoot } from "@/components/Dialog"
import { DialogTrigger } from "./DialogTrigger"
import { useElemRef } from "@/hooks/useElemRef"
import { GlobalStage, useGlobalStore } from "@/store/global"
import { MainGame } from "./MainGame"
import TopLayer from "@/components/TopLayer"

export const Stages = () => {
    const globalStore = useGlobalStore()

    const containerRef = useElemRef()
    return (
        <div
            ref={containerRef}
            style={{ height: "100%", width: "100%", position: "relative" }}
        >
            {GlobalStage.LOADING === globalStore.globalStage && (
                <StageLoading />
            )}
            {GlobalStage.MAIN_GAME === globalStore.globalStage && (
                <DialogRoot>
                    <MainGame />
                    <DialogTrigger />
                </DialogRoot>
            )}
            <TopLayer
                active={globalStore.topLayerActive}
                onDropEnd={() => {
                    if (
                        globalStore.globalStage === GlobalStage.LOADING &&
                        globalStore.topLayerActive
                    ) {
                        // 下拉动画结束：延迟500ms后切换页面并复位 TopLayer
                        setTimeout(() => {
                            globalStore.setGlobalStage(GlobalStage.MAIN_GAME)
                            globalStore.setTopLayerActive(false)
                        }, 300)
                    }
                }}
            />
        </div>
    )
}
